export default {
  wx: [
    ['[微笑]', '/::)'],
    ['[撇嘴]', '/::~'],
    ['[色]', '/::B'],
    ['[发呆]', '/::|'],
    ['[得意]', '/:8-)'],
    ['[流泪]', '/::&lt;'], 
    ['[害羞]', '/::$'],
    ['[闭嘴]', '/::X'],
    ['[睡]', '/::Z'],
    ['[大哭]', '/::&#039;('],
    ['[尴尬]', '/::-|'],
    ['[发怒]', '/::@'],
    ['[调皮]', '/::P'],
    ['[呲牙]', '/::D'],
    ['[惊讶]', '/::O'],
    ['[难过]', '/::('],
    ['[囧]', '/:--b'],
    ['[抓狂]', '/::Q'],
    ['[吐]', '/::T'],
    ['[偷笑]', '/:,@P'],
    ['[愉快]', '/:,@-D'],
    ['[白眼]', '/::d'],
    ['[傲慢]', '/:,@o'],
    ['[困]', '/:|-)'],
    ['[惊恐]', '/::!'],
    ['[憨笑]', '/::&gt;'],
    ['[悠闲]', '/::,@'],
    ['[咒骂]', '/::-S'],
    ['[疑问]', '/:?'],
    ['[嘘]', '/:,@x'],
    ['[晕]', '/:,@@'],
    ['[衰]', '/:,@!'],
    ['[骷髅]', '/:!!!'],
    ['[敲打]', '/:xx'],
    ['[再见]', '/:bye'],
    ['[擦汗]', '/:wipe'],
    ['[抠鼻]', '/:dig'],
    ['[鼓掌]', '/:handclap'],
    ['[坏笑]', '/:B-)'],
    ['[右哼哼]', '/:@&gt;'],
    ['[鄙视]', '/:&gt;-|'],
    ['[委屈]', '/:P-('],
    ['[快哭了]', '/::&#039;|'],
    ['[阴险]', '/:X-)'],
    ['[亲亲]', '/::*'],
    ['[可怜]', '/:8*'],
    ['[笑脸]', '[Happy]'],
    ['[生病]', '[Sick]'],
    ['[脸红]', '[Flushed]'],
    ['[破涕为笑]', '[Lol]'],
    ['[恐惧]', '[Terror]'],
    ['[失望]', '[LetDown]'],
    ['[无语]', '[Duh]'],
    ['[嘿哈]', '[Hey]'],
    ['[捂脸]', '[Facepalm]'],
    ['[奸笑]', '[Smirk]'],
    ['[机智]', '[Smart]'],
    ['[皱眉]', '[Concerned]'],
    ['[耶]', '[Yeah!]'],
    ['[吃瓜]', '[Onlooker]'],
    ['[加油]', '[GoForIt]'],
    ['[汗]', '[Sweats]'],
    ['[天啊]', '[OMG]'],
    ['[Emm]', '[Emm]'], 
    ['[社会社会]', '[Respect]'],
    ['[旺柴]', '[Doge]'],
    ['[好的]', '[NoProb]'],
    ['[打脸]', '[MyBad]'],
    ['[哇]', '[Wow]'],
    ['[翻白眼]', '[Boring]'],
    ['[666]', '[Awesome]'],
    ['[让我看看]', '[LetMeSee]'],
    ['[叹气]', '[Sigh]'],
    ['[苦涩]', '[Hurt]'],
    ['[裂开]', '[Broken]'],
    ['[嘴唇]', '/:showlove'],
    ['[爱心]', '/:heart'],
    ['[心碎]', '/:break'],
    ['[拥抱]', '/:hug'],
    ['[强]', '/:strong'],
    ['[弱]', '/:weak'],
    ['[握手]', '/:share'],
    ['[胜利]', '/:v'],
    ['[抱拳]', '/:@)'],
    ['[勾引]', '/:jj'],
    ['[拳头]', '/:@@'],
    ['[OK]', '/:ok'],
    ['[合十]', '[Worship]'],
    ['[啤酒]', '/:beer'],
    ['[咖啡]', '/:coffee'],
    ['[蛋糕]', '/:cake'],
    ['[玫瑰]', '/:rose'],
    ['[凋谢]', '/:fade'],
    ['[菜刀]', '/:pd'],
    ['[炸弹]', '/:bome'],
    ['[便便]', '/:shit'],
    ['[月亮]', '/:moon'],
    ['[太阳]', '/:sun'],
    ['[庆祝]', '[Party]'],
    ['[礼物]', '/:gift'],
    ['[红包]', '[Packet]'],
    ['[发]', '[Rich]'],
    ['[福]', '[Blessing]'],
    ['[烟花]', '[Fireworks]'],
    ['[爆竹]', '[爆竹]'],
    ['[猪头]', '/:pig'],
    ['[跳跳]', '/:jump'],
    ['[发抖]', '/:shake'],
    ['[转圈]', '/:circle'],
  ],
  yun: [
    ['[微笑]', '/::)'],
    ['[色]', '/::B'],
    ['[得意]', '/:8-)'],
    ['[流泪]', '/::<'],
    ['[害羞]', '/::$'],
    ['[闭嘴]', '/::X'],
    ['[发怒]', '/::@'],
    ['[呲牙]', '/::D'],
    ['[惊讶]', '/::O'],
    ['[难过]', '/::('],
    ['[酷]', '/::+'],
    ['[流汗]', '/::L'],
    ['[奋斗]', '/:,@f'],
    ['[疑问]', '/:?'],
    ['[晕]', '/:,@@'],
    ['[委屈]', '/:P-(']
  ],
  extra: [
    ['[刀]', '/:kn'],
    ['[哈欠]', '/::-O'],
    ['[饥饿]', '/::g'],
    ['[举手]', '/:hand'],
    ['[可爱]', '/:,@-D'],
    ['[酷]', '/::+'],
    ['[篮球]', '/:basketb'],
    ['[冷汗]', '/:--b'],
    ['[米饭]', '/:rice'],
    ['[乒乓球]', '/:pingpong'],
    ['[糗大了]', '/:&-('],
    ['[闪电]', '/:li'],
    ['[摊手]', '/:tanshou'],
    ['[西瓜]', '/:<W>'],
    ['[吓]', '/:@x'],
    ['[元气满满]', '/:full'],
    ['[在吗]', '/:there'],
    ['[足球]', '/:footb'],
    ['[左哼哼]', '/:<@']
  ]
}